<template>
  <div></div>
</template>
<script>
import { getUrlQuery } from '@/common/util'
import evaluateService from '@/backend/services/evaluate/evaluate'
import '@/backend/styles/evaluate/base.scss'

export default {
  data() {
    return {
      urlData: ''
    }
  },
  methods: {
    async init() {
      let { urlData } = this
      try {
        if (urlData) {
          let res = await evaluateService.getDetail({
            ...urlData
          })
          if (res.status !== 200) {
            this.$router.push({ name: 'status', query: { status: 5 } })
            return false
          }
          switch (res.data.evaluationStatus) {
            case 0: // 待评价
              this.$router.push({
                name: 'evaluates',
                query: urlData
              })
              break
            case 1: // 已评价
              this.$router.push({ name: 'status', query: { status: 1 } })
              break
            case 2: // 失效
              this.$router.push({ name: 'status', query: { status: 2 } })
              break
            default:
              // 加载异常
              this.$router.push({ name: 'status', query: { status: 5 } })
          }
        }
      } catch (error) {
        this.$router.push({ name: 'status', query: { status: 5 } })
      }
    }
  },
  mounted() {
    this.urlData = getUrlQuery()
    localStorage.setItem('evaluationId', this.urlData.evaluationId)
    this.init()
  },
  beforeRouteEnter(to, from, next) {
    next()
  }
}
</script>
